<template>
  <div>
    <div class="about">
      <div :class="'header-image default-header-' + rand">
        <SubTopNav v-if="title" :title="title" />
      </div>

      <div class="page-content animated fadeInUp xitem-grid">
        <div v-if="contentImages" class="contentImg">
          <img :src="baseDomain + contentImages" v-if="contentImages" />
        </div>
        <div v-html="contentBody"></div>

        <div class="sector-grid">
          <div v-for="item in group" :key="item.nid" class="sector-item">
            <div class="img" v-if="item && item.field_content_image_s_"><img :src="baseDomain + item.field_content_image_s_" v-if="item.field_content_image_s_" /></div>
            <div class="name">
              <h5 v-html="item.title"></h5>
              <div v-html="item.body"></div>
            </div>
          </div>
        </div>

        <!-- <div  class="content-body item animated fadeInUp" v-for="(item, index) in contentBody" :key="index">
	    			<div class="body-row">
	    				<div class="body-image" v-if="contentImages && contentImages[index]">
	    					<img :src="contentImages[index].url">
	    				</div>
	    				<div v-if="index == 0">
			    			<h3>{{ tagline }}</h3>
			    			<div v-html="item.value"></div>
			    		</div>
			    		<div v-else v-html="item.value"></div>
		    			
		    		</div>
	    			
	    		</div> -->
      </div>
      <div class="block">&nbsp;</div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapState } from "vuex"
import SubTopNav from "@/components/SubTopNav.vue"
import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const ContentRepository = RepositoryFactory.get("content")

export default {
  name: "opportunity",
  components: {
    SubTopNav,
  },
  data: function() {
    return {
      content: null,
      image: null,
      featuredImage: null,
      contentImages: null,
      contentBody: null,
      title: null,
      group: [],
      rand: 1,
      tagline: null,
      siblings: [],
    }
  },
  methods: {
    async getNodeWithAlias(alias) {
      // var id = "2"
      const { data } = await ContentRepository.getNodeWithAlias(alias)
      // console.log('home page data', data)

      this.title = data[0].title
      this.tagline = data[0].body.summary
      this.contentImages = data[0].field_content_image_s_
      this.contentBody = data[0].body

      // this.getSiblings()
    },

    async getGroup(type) {
      const { data } = await ContentRepository.getGroup(type)
      this.group = data.reverse()
      // console.log('data', data)

      // this.getSiblings()
    },
    // getSiblings(){
    // 	var navigation = this.$session.get('navigation')
    // 	var pageTitle = this.title.toLowerCase()
    // 	if (navigation && navigation.length){
    // 		var menuItemArr = navigation.filter(function (item){
    //         return item.name.toLowerCase() == pageTitle
    //       })

    //       var menuItem = menuItemArr[0]
    //       var menuParent = menuItem.parent

    //       if (menuParent){
    //       	var siblingsArr = navigation.filter(function (item){
    //       		return (item.parent == menuParent) && (item.name.toLowerCase() != pageTitle)
    //       	})

    //       	this.siblings = siblingsArr

    //       }

    //       // console.log('sub expertise', this.subExpertise)
    // 	}
    // }
  },
  mounted() {
    var alias = this.$route.params.alias
    // console.log('alias', alias)
    if (alias) {
      this.getNodeWithAlias(alias)
    }

    if (alias == "agriculture") {
      this.getGroup("agriculture_")
    }

    this.rand = Math.floor(Math.random() * 8) + 1
  },
  computed: {
    ...mapState(["baseDomain"]),
  },
}
</script>
<style scoped>
.contentImg {
  width: 600px;
  overflow: hidden;
  margin-bottom: 25px;
  margin-left: 50px;
  float: right;
}

.page-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  xgrid-row: 1;
  grid-gap: 25px;
}

.item-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 25px;
}

.page-grid .item {
  xbackground: #ccc;
  xpadding: 10px;
}

.page-grid .item:nth-child(1) {
  xborder: 1px solid red;
  grid-column: 1 / 4;
}

.page-grid .item:nth-child(1) .body-row {
  display: grid;
  grid-template-columns: 1fr 2fr;
  background: #f2f2f2;
  xborder: 10px solid #e1e1e1;
  xpadding: 25px;
  grid-gap: 25px;
  margin-top: 25px;
  xborder-radius: 0px 0px 85px 0px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(1) {
  background: #ccc;
  padding: 25px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(2) h3 {
  margin-top: 55px;
}

.page-grid .item:nth-child(1) .body-row div:nth-child(2) {
  padding: 25px;
}

.page-grid img {
  max-width: 100%;
}

.page-grid .item:nth-child(2) {
  border-top: 5px solid #cc0000;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(3) {
  border-top: 5px solid #ffcc33;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(4) {
  border-top: 5px solid #339900;
  padding-top: 20px;
  margin-top: 20px;
}

.page-content {
  text-align: left;
  xmargin-bottom: 30px;
}

.image-break {
  height: 300px;
  xbackground: #ccc;
  margin-top: 35px;
  margin-bottom: 35px;
}

.image-box {
  height: 300px;
  top: 0;
  left: 0;
  filter: grayscale(100%);
  xopacity: 0.3;
}

.image-text {
  margin-top: -300px;
  z-index: 50;
  position: relative;
}

.image-text a {
  color: #fff;
}

.image-text .container div {
  background: rgba(255, 102, 0, 0.8);
  color: #fff;
  padding: 105px 50px 50px 50px;
  float: left;
  width: 50%;
  height: 300px;
}

.sector-grid {
  display: grid;
  grid-gap: 25px;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 10px 0px;
}

.sector-grid .img {
  max-height: 200px;
  overflow: hidden;
  margin-bottom: 25px;
}

.page-content .content-body:nth-child(2n) .image-text .container div {
  float: right;
  background: rgba(102, 153, 51, 0.8);
}

.block {
  clear: both;
}

.body-row {
  xpadding: 25px;
}

.page-content img {
  max-width: 100%;
  margin-bottom: 25px;
}

@media (max-width: 768px) {
  .contentImg {
    width: 100%;
  }
}
</style>
